const SERVICES = {
  COURSE : Symbol('Course'),
  PAYMENT : Symbol('Payment'),
  LESSON : Symbol('Lesson'),
  QUIZ   : Symbol('Quiz'),
  UNIT   : Symbol('Unit'),
  AUTH   : Symbol('Auth'),
  USER   : Symbol('User'),
  CERTIFICATE   : Symbol('Certificate'),
  CERTIFICATEVALIDATION   : Symbol('CertificateValidation')
};

export default SERVICES;
